<template>
  <div class="statistics">
    <div class="text">
      <div class="monitor-header">隐患排查</div>
      <div class="monitor">
        <el-table :data="tableData" border style="width: 100%" :header-cell-style="tableTouStyle">
          <el-table-column align="center" label="序号"  type="index" width="60"/>
          <el-table-column align="center" prop="date" label="日期" width="180" />
          <el-table-column align="center" prop="name" label="姓名" width="180" />
          <el-table-column align="center" prop="address" label="地址" />
        </el-table>
        <list-page ref="page" :total="totalNum" @chileByCurrentPage="chileByCurrentPage($event)" />
      </div>
    </div>
  </div>
</template>

<script>
import { getPeople } from "@/api/worker.js";
import ListPage from './list_main_page'

export default {
  name: "Gaojing",
  components: {
    ListPage
  },
  data() {
    return {
      drawer: true,
      activeName: "1",
      totalNum: null,
      pageNum: 1,
      pageSize: 10,
      // 表格头部样式
      tableTouStyle: {
        background: '#f1f1f1',
        color: '#000',
        'font-size': '14px',
        'text-align': 'center'
      },
      tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }]
    };
  },
  props: {
    msg: String,
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // 子组件传给父组件的分页参数
    chileByCurrentPage(val) {
      this.$nextTick(function() {
        this.pageNum = val
      })
    },
    getListData() {},
  },
};
</script>

<style scoped>
.statistics {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 15%;
  left: 20%;
}
.text {
  width: 60%;
  height: 60%;
  padding: 0 20px 20px 20px;
  color: #000;
  background: #fff;
}
.monitor-header {
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
}
.monitor {
  width: 100%;
  height: calc(100% - 40px);
}
</style>